module.exports = __webpack_public_path__ + "static/other/gamePlumbing.97d1fc8d.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gamePlumbing.json
// module id = 2295
// module chunks = 0